module.exports = __webpack_public_path__ + "img/云端.41ccf9b2.png";